import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {clearInterval, setInterval} from 'worker-timers'
import {detectIncognito} from 'detectincognitojs'

Vue.use(Vuex, axios)

export default new Vuex.Store({
  state: {
    // ERRORES
    errorHeaders: false,
    errorMethods: false,
    errorSession: false,
    errorHashExpired: false,
    errorNoMethods: false,
    sessionExpiredError: false,
    errorIncognitoMode: false,
    // SESSION
    idSessionHash: '',
    color: '#4050B5',
    gradientSesion: 'ffd200,1feaea',
    // HEADERS
    isHeaders: false,
    is_payed: false,
    x_country: '',
    x_commerce: '',
    x_customerid: '',
    x_channel: '',
    x_usrtx: '',
    x_api_version: '',
    x_language: '',

    // CONFIG
    appName: 'Payment',
    apiRoute: process.env.VUE_APP_URL_BFF,

    //timer
    timerValue: null, // Initial timer value in seconds
    timerInterval: null,
    progressLineInterval: null,
    progressLinePercent: 100,

    // VARIABLES DE SERVICIOS
    paymentMethods: null,
    data: null,

    paymeData: null,

    //Estado de la transacción
    status: {
      status: null,
      subStatus: null
    }
  },
  mutations: {
    startCountdown(state) {
      console.log('startCountdown', process.env.VUE_APP_COUNTDOWN_TIMER)
      state.timerValue = parseInt(process.env.VUE_APP_COUNTDOWN_TIMER) || 300

      state.timerInterval = setInterval(() => {
        if (state.timerValue > 0) {
          state.timerValue--
        } else {
          clearInterval(state.timerInterval)
          state.timerValue = 0
          state.sessionExpiredError = true
        }
      }, 1000)
    },
    startBarCountdown(state) {
      state.progressLineInterval = setInterval(
        () => {
          if (state.progressLinePercent >= 0) {
            state.progressLinePercent -= 0.1
          } else {
            state.progressLinePercent = 0
            clearInterval(state.progressLineInterval)
          }
        },
        parseInt(process.env.VUE_APP_COUNTDOWN_TIMER) || 300
      )
    },
    stopCountdown(state) {
      state.timerValue = 0
      clearInterval(state.timerInterval)
    },
    stopBarCountdown(state) {
      state.progressLinePercent = 0
      clearInterval(state.progressLineInterval)
    },
    setIdSessionHash(state, payload) {
      state.idSessionHash = payload
      console.log('state.idSessionHash', state.idSessionHash)
    },
    setColorSesion(state, payload) {
      state.color = payload
      console.log('state.color', state.color)
    },
    setGradientSesion(state, payload) {
      state.gradientSesion = payload
      console.log('state.gradient', state.gradientSesion)
    },
    getHeaders(state) {
      const auth = {
        headers: {
          'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }
      }
      axios
        .get(`${state.apiRoute}/session/headers/${state.idSessionHash}`, auth)
        .then((response) => {
          state.x_country = response.data.headers['x-country']
          state.x_commerce = response.data.headers['x-commerce']
          state.x_customerid = response.data.headers['x-customerid']
          state.x_channel = response.data.headers['x-channel']
          state.x_usrtx = response.data.headers['x-usrtx']
          state.x_api_version = response.data.headers['x-api-version']
          state.x_language = response.data.headers['x-language']
          if (response.data.headers['is_payed']) {
            state.is_payed = response.data.headers['is_payed']
          }
          state.isHeaders = true
          if (response.data.status === 'HASH_EXPIRED') {
            state.errorHashExpired = true
          }
        })
        .catch((e) => {
          console.log('Get error ' + e)
          state.errorHeaders = true
        })
    },
    getSessionCache(state, payload) {
      let payment_method = payload
      const auth = {
        headers: {
          'x-country': state.x_country,
          'x-commerce': state.x_commerce,
          'x-customerid': state.x_customerid,
          'x-channel': state.x_channel,
          'x-usrtx': state.x_usrtx,
          'x-api-version': state.x_api_version,
          'selected-payment': payment_method,
          'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
        }
      }
      axios
        .get(`${state.apiRoute}/session/checkout/payme/${state.idSessionHash}`, auth)
        .then((response) => {
          state.paymeData = response.data.payme
          console.log('state.paymeData', state.paymeData)
          // eslint-disable-next-line no-console
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log('Get error ' + e)
          state.errorSession = true
        })
    },
    getPaymentMethods(state) {
      const auth = {
        headers: {
          'x-country': state.x_country,
          'x-commerce': state.x_commerce,
          'x-customerid': state.x_customerid,
          'x-channel': state.x_channel,
          'x-usrtx': state.x_usrtx,
          'x-api-version': state.x_api_version,
          'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
        }
      }
      axios
        .get(`${state.apiRoute}/payment/methods/${state.idSessionHash}`, auth)
        .then((response) => {
          state.paymentMethods = response.data.result
          if (response.data.result.paymentMethods.length === 0) {
            state.errorNoMethods = true
          }

          console.log('state.paymentMethods', state.paymentMethods)
          // eslint-disable-next-line no-console
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log('Get error ' + e)
          state.errorMethods = true
        })
      // eslint-disable-next-line no-console
    },
    postErrorStatus(state, errorType) {
      const auth = {
        headers: {
          'x-country': state.x_country,
          'x-commerce': state.x_commerce,
          'x-customerid': state.x_customerid,
          'x-channel': state.x_channel,
          'x-usrtx': state.x_usrtx,
          'x-api-version': state.x_api_version,
          'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
        }
      }
      const body = {
        purchaseOperationNumber: state.x_usrtx,
        status: null,
        subStatus: null,
        fraudScreening: null,
        idSessionHash: state.idSessionHash
      }

      if (errorType.code === 'ERR_SESSION_EXPIRED') {
        body.status = 'PAYMENT_SESSION_EXPIRED'
        body.subStatus = 'PAYMENT_SESSION_EXPIRED'
      } else if (errorType.code === 'REJECTED_GET_BACK') {
        body.status = 'REJECTED_GET_BACK'
        body.subStatus = 'REJECTED_GET_BACK'
      } else if (errorType.code === 'ERR_BINES_VALIDATION' || errorType.code === 'ERR_BINES_FAILED') {
        body.status = 'ERR_BINES'
        body.subStatus = errorType.code
      } else {
        body.status = 'PAYMENT_ERROR'
        body.subStatus = errorType.code
      }
      state.status = body
      console.log('errorStatus', body)
      axios
        .post(`${state.apiRoute}/payment/status`, body, auth)
        .then(() => {
          // eslint-disable-next-line no-console
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log('Get error ' + e)
        })
      // eslint-disable-next-line no-console
    },
    backButtonRedirect(state, backType) {
      const auth = {
        headers: {
          'x-country': state.x_country,
          'x-commerce': state.x_commerce,
          'x-customerid': state.x_customerid,
          'x-channel': state.x_channel,
          'x-usrtx': state.x_usrtx,
          'x-api-version': state.x_api_version,
          'x-back-type': backType,
          'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
        }
      }
      // Revisar caso "is_payed", se está enviando null para status y subStatus ya que no se puede obtener directamente
      // esta información cuando se muestra el error.
      axios
        .get(`${state.apiRoute}/payment/back_button/${backType}&${state.status.status}&${state.status.subStatus}&${state.idSessionHash}`, auth)
        .then((response) => {
          window.parent.location.href = response.data.url
          // eslint-disable-next-line no-console
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log('Get error ' + e)
        })
      // eslint-disable-next-line no-console
    },
    checkIncognitoMode(state) {
      detectIncognito().then((result) => {
        console.log(result.browserName, result.isPrivate)
        if (result.isPrivate) {
          state.errorIncognitoMode = true
        }
      })
    }
  }
})
